import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
/* eslint-disable */
// import $ from 'jquery';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import "./assets/js/utils";
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store} from './store/aeroTechPubStore';
// import i18n (needs to be bundled ;)) 
import './i18n';
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
 
    <Provider store={store}>
      <App />
    </Provider>
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

